/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Popover } from "@headlessui/react";

import { Icon } from "components";
import { WidgetForm } from "./WidgetForm";

import * as Styled from "./styles";

export const SupportWidgetButton = () => {
  return (
    <Popover style={{
      zIndex: 9999,
      backgroundColor: "white",
    }}>
      <Popover.Panel
        style={{
          position: "fixed",
          bottom: "10%",
        }}
      >
        <WidgetForm />
      </Popover.Panel>

      <Popover.Button
        style={{
          height: "50px",
          lineHeight: "50px",
          color: "#353535",
          paddingLeft: 0,
          border: "none",
          backgroundColor: "transparent",
        }}>
        <Styled.Item>
          <Icon name="mail-gray" />
          Suporte
        </Styled.Item>
      </Popover.Button>
    </Popover>
  );
};
